const langs = ['zh', 'en', 'tw', 'jp']
const defaultLangKey = 'en'

module.exports = {
  langs: langs,
  defaultLangKey: defaultLangKey,
}
